import { Injectable } from "@angular/core";
import { Observable, ReplaySubject, Subject } from "rxjs";
import { ActivationRecord } from "./bulk-activation/models/ActivationRecord";

@Injectable({
    providedIn: 'root'
})
export class ActivationCodeService {

    constructor() { }

    private dataSubject = new ReplaySubject<ActivationRecord[]>(1);

    setData(data: ActivationRecord[]) {
        this.clearData()
        this.dataSubject.next(data);
    }

    getData(): Observable<ActivationRecord[]> {
        return this.dataSubject.asObservable();
    }

    clearData() {
        this.dataSubject = new ReplaySubject<ActivationRecord[]>(1);//reset
    }
    
}